export const emptyFocused = "uPb";
export const emptyOther = "vPb";
export const emptyFolder = "wPb";
export default {emptyFocused,emptyOther,emptyFolder};